import React, { FC } from 'react';
import css from './markdowns.scss';
import {
  Text,
  SectionHelper,
  SectionHelperAppearance,
} from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { DataHooks } from '../../constants/dataHooks';

export const blockquoteAppearances = ['warning', 'standard', 'success'];
export const mapAppearanceToTitle = {
  warning: 'warning',
  standard: 'note',
  success: 'tip',
};

type Props = {
  content: string;
  className: (typeof blockquoteAppearances)[number];
};

export const Blockquote: FC<Props> = ({ content, className }) => {
  const { titleKey, appearance } = getSectionHelperParams(className);
  const { t } = useTranslation();
  return (
    <blockquote className={css.blockquote}>
      <SectionHelper
        dataHook={DataHooks.BlockquoteSectionHelper}
        appearance={appearance}
        fullWidth={true}
      >
        <Text dataHook={DataHooks.BlockquoteTitle} size="medium" weight="bold">
          {t(`app.template-page.step-by-step.section-helper.title.${titleKey}`)}
        </Text>
        <br />
        <Text
          dataHook={DataHooks.BlockquoteTextContent}
          size="small"
          weight="thin"
        >
          {content}
        </Text>
      </SectionHelper>
    </blockquote>
  );
};

const getSectionHelperParams = (
  className: string,
): { titleKey: string; appearance: SectionHelperAppearance } => {
  const appearance = blockquoteAppearances.includes(className)
    ? (className as SectionHelperAppearance)
    : 'standard';

  return { titleKey: mapAppearanceToTitle[appearance], appearance };
};
